import React from 'react';
import DemandesBoard from './DemandesBoard';

export default function DemandeTable({ typeFilter = 'Attestation' }) {
    return <DemandesBoard typeFilter={typeFilter} emptyLabel="Aucune demande d'attestation" />;
}
